<template>
  <b-container>
    <b-sidebar
      id="sidebar-1"
      right
      width="40rem"
      backdrop shadow
      z-index="2000"
      :visible="showSidebar"
      @change="updateSidebar"
    >
      <!-- If the sidebar content from the store is infra-details, the sidebar
      will display infra information based on the mapSelectedInfra -->
      <infrastructure-details
        v-if="sidebarContent === 'infra-details' && mapSelectedInfra"
      ></infrastructure-details>
      <!-- If the sidebar content from the store is inst-details, the sidebar
      will display infra information based on the mapSelectedInst -->
      <instrument-details
        :inst="mapSelectedInst"
        v-if="sidebarContent === 'inst-details' && mapSelectedInst"
      ></instrument-details>
    </b-sidebar>
  </b-container>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import InfraDetails from './MapDetailsInfra';
import InstDetails from './MapDetailsInst';

export default {
  components: {
    'infrastructure-details': InfraDetails,
    'instrument-details': InstDetails,
  },
  methods: {
    ...mapActions([
      'toggleSidebar',
    ]),
    /**
     * This updates the @change event on the sidebar which will
     * make the sidebar visible or hidden
     * @param {*} value - boolean
     */
    updateSidebar(value) {
      this.toggleSidebar({ showSidebar: value });
    },
  },
  computed: {
    ...mapState({
      showSidebar: (state) => state.showSidebar,
      sidebarContent: (state) => state.sidebarContent,
      mapSelectedInfra: (state) => state.mapSelectedInfra,
      mapSelectedInst: (state) => state.mapSelectedInst,
    }),
  },
};
</script>
<style>
/** */
.b-sidebar > .b-sidebar-body  {
  overflow-y: hidden;
}
</style>
